import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '../fi-wrapper-table-cell-base';
import { FiProfileSizes, IUserProfile } from '../../../profile-icon/profile-icon.component';

@Component({
    selector: 'fi-wrapper-table-item-profile-cell',
    templateUrl: './fi-wrapper-table-item-profile-cell.component.html',
    styleUrl: './fi-wrapper-table-item-profile-cell.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-wrapper-table-item-profile-cell' },
    standalone: false,
})
export class FiWrapperTableItemProfileCellComponent extends FiWrapperTableCellBase<IUserProfile> {
    @Input() noProfileText = '-';
    @Input() profileSize: FiProfileSizes = FiProfileSizes.Size24px
    protected readonly FiProfileSizes = FiProfileSizes;
}
